// Settings Page

import React, { useState } from 'react';
import MainLayout from '../components/layout/MainLayout.jsx';
import { Card, Button } from '../components/common/index.js';
import { FiSave, FiUser, FiMail, FiShield, FiHelpCircle, FiLock } from 'react-icons/fi';
import ChangePasswordModal from '../components/auth/ChangePasswordModal.jsx';
import AppUpdateNotice from '../components/settings/AppUpdateNotice.jsx';

const SettingsPage = () => {
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);

  return (
    <MainLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="animate-fade-in-up">
          <h1 className="text-2xl font-bold text-slate-900">Settings</h1>
          <p className="text-slate-500 text-sm mt-0.5">Manage your application settings</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* General Settings */}
          <div className="lg:col-span-2 space-y-5">
            <Card title="Security" subtitle="Manage your account credentials">
              <div className="flex items-center justify-between py-1">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-violet-50 flex items-center justify-center">
                    <FiLock className="w-5 h-5 text-violet-600" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-slate-800">Admin Password</p>
                    <p className="text-xs text-slate-400">Update your login password</p>
                  </div>
                </div>
                <Button variant="primary" size="sm" onClick={() => setChangePasswordOpen(true)}>
                  Change Password
                </Button>
              </div>
            </Card>

            <AppUpdateNotice />

            <Card title="General Settings" subtitle="Basic application configuration">
              <div className="space-y-5">
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">Application Name</label>
                  <div className="relative">
                    <FiUser className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 w-4 h-4" />
                    <input type="text" defaultValue="CAP Admin" className="w-full pl-11 pr-4 py-3 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-violet-300 focus:border-violet-400 transition-all" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">Email Address</label>
                  <div className="relative">
                    <FiMail className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 w-4 h-4" />
                    <input type="email" defaultValue="admin@cap.com" className="w-full pl-11 pr-4 py-3 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-violet-300 focus:border-violet-400 transition-all" />
                  </div>
                </div>
                <div className="flex justify-end pt-2">
                  <Button variant="primary" size="md">
                    <FiSave className="w-4 h-4 mr-2" /> Save Changes
                  </Button>
                </div>
              </div>
            </Card>
          </div>

          {/* Sidebar info */}
          <div className="space-y-4">
            <Card title="Resources">
              <div className="space-y-2">
                {[
                  { label: 'Privacy Policy', icon: FiShield },
                  { label: 'Terms & Conditions', icon: FiShield },
                  { label: 'Support', icon: FiHelpCircle },
                ].map((item) => {
                  const I = item.icon;
                  return (
                    <button
                      key={item.label}
                      className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors text-left"
                    >
                      <I className="w-4 h-4 text-slate-400" />
                      {item.label}
                    </button>
                  );
                })}
              </div>
            </Card>

            <div className="bg-slate-900 rounded-2xl p-5 text-white">
              <p className="text-slate-400 text-xs font-semibold uppercase tracking-wide mb-2">Version</p>
              <p className="text-xl font-bold mb-1">v1.0.0</p>
              <p className="text-slate-400 text-sm">CAP Admin Panel</p>
            </div>
          </div>
        </div>
      </div>
      <ChangePasswordModal isOpen={changePasswordOpen} onClose={() => setChangePasswordOpen(false)} />
    </MainLayout>
  );
};

export default SettingsPage;
